require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.map');
module.exports = require('../modules/$.core').Map;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/es6/map.js
 ** module id = 384
 ** module chunks = 0
 **/